
 <template lang="">
 <UserLayout :showNavBar="true"  pageTitle="Personalizza azienda">
      <template #page-content="props">
        <v-card
                        class="form-card" 
                        outlined 
                        >
        <FrmSettings></FrmSettings>
        </v-card>
     </template>
 </UserLayout> 
</template>
<script>
import FrmSettings from "../components/FrmSettings/FrmSettings.vue";
import UserLayout from "../layout/UserLayout";
import SessionHelper from "../utils/SessionHelper";
export default {
  mounted(){
    
    SessionHelper.checkRedirects(this.$route.params.companyAlias);
  },
  components: {
    FrmSettings,
    UserLayout,
  },
};
</script>
<style lang="">
  
</style> 